<template>
  <div style="height: 100%">
    <config-drawer/>
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </div>
</template>

<script>
import store from '../ems-store';
import ConfigDrawer from '../components/ConfigDrawer.vue';

export default {
  name: 'Index',
  components: {
    ConfigDrawer,
  },
  created() {
    const storeName = 'emsDashboard';
    if (!this.$store.hasModule(storeName)) {
      this.$store.registerModule(storeName, store);
    }
    this.$store.commit('helper/setShowHeaderButtons', true);
  },
  beforeDestroy() {
    this.$store.commit('helper/setShowHeaderButtons', false);
  },
};
</script>
